import React from 'react';
import { AGENTS, CLOUD_AGENTS } from '../Tabs/constants';
import Table from '../Table';
import { useSelector } from 'react-redux';
import { selectCloudAgents, selectUserAgents } from 'store/Agents/selectors';
import RunStatusLog from '../RunStatusLog';
import CloudAgentsTable from '../CloudAgentsTable';

const TableContent = ({ selectedTab }) => {
  const userAgents = useSelector(selectUserAgents);
  const cloudAgents = useSelector(selectCloudAgents);

  if (selectedTab === AGENTS) return <Table agents={ userAgents } />;
  if (selectedTab === CLOUD_AGENTS) return <CloudAgentsTable agents={ cloudAgents } />;
  return <RunStatusLog />;
};

export default TableContent;
